import Vue from 'vue'
import VueGtag from 'vue-gtag'

export default function (context, inject) {
  Vue.use(
    VueGtag,
    {
      config: { id: context.$config.ga4MeasurementId },
      enabled: !context.$config.dev
    },
    context.app.router
  )
}
